"use client";

import Link from "next/link";
import { useParams, usePathname } from "next/navigation";
import { menuList } from "@/app/data/index";
import type { LinkProp } from "@/app/data/index";
import { useState } from "react";
import clsx from "clsx";

function Item({ menu }: { menu: LinkProp }) {
  let pathname = usePathname();
  const { detailId } = useParams();
  pathname = detailId ? pathname.replace(`/${detailId}`, "") : pathname;

  const [active, setActive] = useState(false);
  return (
    <li
      key={menu.name}
      className={clsx(
        "w-[150px] h-full text-center text-white text-[20px]/[50px] font-bold relative",
        {
          "bg-[#437dcc]":
            active ||
            menu.link == pathname ||
            menu?.children?.some((m) => m.link == pathname),
        }
      )}
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
      onClick={() => {
        setActive(false);
      }}
    >
      <Link href={menu?.children?.[0]?.link ?? menu.link} className="block">{menu.name}</Link>
      {active && (
        <ul className="w-full absolute pt-[3px] z-2000">
          {menu?.children?.map((m) => (
            <li
              key={m.name}
              onClick={() => setActive(false)}
              className="h-[42px] text-center text-[18px]/[42px] bg-[#2b69c0] hover:bg-[#91caff]"
            >
              <Link href={m.link} className="block">{m.name}</Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
}

export function NavMenu() {
  return (
    <div className="bg-[#07408e]">
      <ul className="w-[1200px] h-[50px] mx-auto flex justify-between">
        {menuList.map((menu) => (
          <Item key={menu.name} menu={menu}></Item>
        ))}
      </ul>
    </div>
  );
}
